import { Injectable } from '@angular/core'
import { TranslateService } from '@ngx-translate/core'
import copy from 'copy-text-to-clipboard'
import { IdentityService } from 'main/services/identity.service'
import { MediaOperationsService } from '../services/mediaOperations.service'
import { NotifyService } from 'common/util/services/notify.service'
import { BaseOperation } from './base'

@Injectable({ providedIn: 'root' })
class CopyPathOp extends BaseOperation {
  icon = 'far fa-copy'
  showInAdvancedContextMenu = true
  supportsDirs = true
  supportsBundles = true
  showInAssetView = true
  weight = 0

  constructor (
    private translate: TranslateService,
    private identity: IdentityService,
    private notify: NotifyService,
  ) {
    super()
    this.label = this.translate.instant('Copy path')
  }

  isVisibleFor (_items) {
    return !this.identity.user?.isExternal
  }

  isEnabledForDir (_dir) {
    return true
  }

  isEnabledForBundle (_bundle) {
    return true
  }

  async runForDir (dir) {
    this.doCopy(dir.fullPath)
  }

  async runForBundle (bundle) {
    this.doCopy(bundle.mainfile.fullPath)
  }

  doCopy (text) {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (navigator.clipboard?.writeText) {
      navigator.clipboard.writeText(text)
    } else {
      copy(text)
    }
    this.notify.success(this.translate.instant('Copied'))
  }
}

MediaOperationsService.register(CopyPathOp)
